import { render, staticRenderFns } from "./nextJsConsumeApi.vue?vue&type=template&id=2b6b0424&"
import script from "./nextJsConsumeApi.vue?vue&type=script&lang=js&"
export * from "./nextJsConsumeApi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports